import {getAlignment, isOnImageLayout} from '../../../selectors/single-settings'
import {getAlignmentClassName} from '../../../selectors/classes'
import {AppProps} from '../../app/interfaces'
import {connect} from '../../runtime-context/connect'
import {getComponentConfig} from '../../../selectors/settings'
import {Divider as DividerPresentation} from './divider'

interface DividerOwnProps {
  width: number
  height: number
}

interface DividerStateProps {
  alignmentClassName: string
  onImage: boolean
}

export interface DividerProps extends DividerOwnProps, DividerStateProps {}

const mapState = ({state}: AppProps): DividerStateProps => ({
  alignmentClassName: getAlignmentClassName(getAlignment(getComponentConfig(state))),
  onImage: isOnImageLayout(state),
})

export const Divider = connect<DividerOwnProps, DividerStateProps>(mapState)(DividerPresentation)
